import { styled } from "@vitality-ds/system";
import BaseContentStyles from "./styles/BaseContent.styles";
import BaseToastStyles from "./styles/BaseToast.styles";
export var BaseToast = styled("div", BaseToastStyles);
export var BaseContent = styled("div", BaseContentStyles);